"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowCover = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var constants_1 = require("../../constants");
var SnowCover = (function () {
    function SnowCover() {
        this.name = GlobalEventName_1.GlobalEventName.SNOW_COVER;
        this.description = 'Decrease temperature 2 steps. Draw 1 card per influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
    }
    SnowCover.prototype.resolve = function (game, turmoil) {
        var canDecreaseTemperature = game.getTemperature() !== constants_1.MAX_TEMPERATURE;
        if (canDecreaseTemperature)
            game.increaseTemperature(game.getPlayers()[0], -2);
        game.getPlayers().forEach(function (player) {
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    };
    return SnowCover;
}());
exports.SnowCover = SnowCover;
//# sourceMappingURL=SnowCover.js.map